module.exports = __webpack_public_path__ + "static/media/Seam_4552.c1c19df2.jpg";